import type { ReplaceMeterStore } from 'routes/meter_replacement/useStore';
import { SetState } from 'zustand';
import type { MeterElectricityDetails } from './components/Electricity';
import type { MeterGasDetails } from './components/Gas';
import type { MeterWaterDetails } from './components/Water';
import type { MeterThermalDetails } from './components/Thermal';
import type { MeterOtherDetails } from './components/Other';

export interface DetailsStepForm {
  detail?: MeterElectricityDetails | MeterGasDetails | MeterWaterDetails | MeterThermalDetails | MeterOtherDetails;
  internalNote?: string;
}

const INITIAL_STATE: DetailsStepForm = {
  detail: undefined,
  internalNote: undefined,
};

export interface DetailsStepSlice extends DetailsStepForm {
  setDetailsStepValues: (values: DetailsStepForm) => void;
  resetDetailsStepSlice: (initValues?: Partial<DetailsStepForm>) => void;
}

export const createDetailsStepSlice = (set: SetState<ReplaceMeterStore>): DetailsStepSlice => ({
  ...INITIAL_STATE,
  setDetailsStepValues: (values: DetailsStepForm) => set(values),
  resetDetailsStepSlice: (initValues = {}) => set({ ...INITIAL_STATE, ...initValues }),
});
